import Model from '../Model';
import BundleReleaseNotesModel from './BundleReleaseNotesModel';

export default class ReleaseNotesListModel extends Model {
	constructor(data) {
		super(data);

		this.releaseNotes = [];
		if (_.isArray(data)) {
			this.releaseNotes = _.map(data, (itemData) => {
			    return this.createReleaseNotesModel(itemData);
			});
		} else {
			this.releaseNotes = [this.createReleaseNotesModel(data)];
		}
	}

	createReleaseNotesModel(itemData) {
		return new BundleReleaseNotesModel({
			content: itemData.content,
			contentType: itemData.syntax || itemData.contentType,
			hasWritePermission: itemData.hasWritePermission
		});
	}
}



// WEBPACK FOOTER //
// ./modules/distribution/core/models/releaseNotes/ReleaseNotesListModel.js